import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "timeCount",
  standalone: false
})
export class TimeCountPipe implements PipeTransform {
  readonly minute_unit = 60;

  transform(seconds: number): string {
    const minute = Math.floor(seconds / this.minute_unit);
    const remainder = Math.floor(seconds % this.minute_unit);
    return `${minute}:${remainder < 10 ? "0" + remainder : remainder}`;
  }
}
